import router from '@/router/index';
import productService from '@/api/productConfigService'

const state = {

    products: [],
    newProduct: '',
    editId: null
}
const getters = {
    productList: state => state.products,
    product: state=> state.newProduct
};

const actions = {
    async addProduct({ commit }, product) {
        await productService.addProduct(product)
        commit('addProducts', product, {root: true})
    },
    async editProduct({ commit }, product) {
        const response = await productService.getPrductById(product.id)
        commit('edit', response.data)
    },
    async updateProduct({commit }, product) {
        await productService.updateProduct(product.id, product)
        commit('updateProduct', product, {root: true})
    },
    async removeProduct({ commit }, product) {
        await productService.removeProduct(product.id)
        commit('removeProduct', product, {root: true})
    }
}
const mutations={    
    edit(state, product) { 
        state.editId = product.code
        state.newProduct = product
        router.push({name: "AddProduct", params: {add: false }});
    }
}

export default{
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}